import React from 'react';

/**
 * Bloc section — parité visuelle avec le modal détail commande produit (Mes commandes).
 */
export default function MesCommandesDetailSection({ title, children, className = '', tone = 'default' }) {
  const toneClass =
    tone === 'muted' ? 'bg-gray-50 border-gray-200' : tone === 'accent' ? 'bg-slate-50 border-gray-200' : '';
  return (
    <div className={`border rounded-lg p-4 ${toneClass} ${className}`.trim()}>
      <h4 className="font-semibold mb-3 text-gray-700">{title}</h4>
      {children}
    </div>
  );
}
